/**
 * @description Checks if the user only has scopes that grant entry to the Video
 * application, meaning they should be redirected there rather than into Access.
 *
 * Both the `videoAdmin` and `videoUser` spellings are accepted. Helium is
 * renaming this scope to `videoUser` (the roles that grant it are the Video
 * app-entry marker, not an admin tier), and this check runs against whatever
 * scope strings the token currently carries. Accepting both keeps the redirect
 * working across the rename; the `videoAdmin` entries can be dropped once the
 * Helium rename is deployed everywhere.
 * @param tokenScopeItem
 * @returns {boolean} True if the user has only video scopes, false otherwise.
 */
export const isVideoOnlyUser = (
  tokenScopeItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >,
) => {
  if (!tokenScopeItem) return false;
  const { org, scope, user } = tokenScopeItem;

  const videoScopes = new Set([
    `o${org?.id}-videoAdmin:w`,
    `o${org?.id}-videoAdmin:r`,
    `o${org?.id}-videoUser:w`,
    `o${org?.id}-videoUser:r`,
  ]);

  const userScope = `user${user?.id}`;

  const filteredScopes = scope?.filter(
    (scopeItem) => !scopeItem.includes(userScope),
  );

  return (
    (filteredScopes?.length ?? 0) > 0 &&
    filteredScopes?.every((scopeItem) => videoScopes.has(scopeItem))
  );
};
